/**
 * Utilitário centralizado para detecção de ambiente.
 * Usar SEMPRE este módulo em vez de checar import.meta.env diretamente.
 *
 * - isDevEnvironment(): true em localhost OU ambiente .dev.agendario.com.br
 * - isLocalhost(): true apenas em localhost
 * - isProduction(): true apenas no ambiente de produção (sem .dev.)
 */

export function isDevEnvironment() {
  return (
    import.meta.env.DEV ||
    import.meta.env.MODE === 'development' ||
    import.meta.env.VITE_API_URL?.includes('.dev.') ||
    window.location.hostname.includes('localhost') ||
    window.location.hostname.includes('.dev.')
  );
}

export function isLocalhost() {
  return (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  );
}

export function isProduction() {
  return !isDevEnvironment();
}

/**
 * Venda de planos (assinatura/cartão) fica OCULTA por padrão durante o go-live de pacotes (PIX).
 * Liga apenas com VITE_FEATURE_PLANS_SALE === 'true'. Default OFF (kill-switch da venda de planos).
 */
export function isPlansSaleEnabled() {
  return import.meta.env.VITE_FEATURE_PLANS_SALE === 'true';
}

/**
 * Tela de Integrações (WhatsApp: config + vitrine de pacotes PIX + histórico).
 * O kill-switch é só de PRODUÇÃO: em DEV/localhost fica SEMPRE visível (para testar);
 * em PRD fica OCULTA por padrão e só liga com VITE_FEATURE_INTEGRATIONS === 'true'.
 */
export function isIntegrationsEnabled() {
  return isDevEnvironment() || import.meta.env.VITE_FEATURE_INTEGRATIONS === 'true';
}
